// src/__internal__/shims/useSyncExternalStore.ts
import React, { useEffect, useState } from "react";
var _a;
var useSyncExternalStore = (_a = React.useSyncExternalStore) != null ? _a : (subscribe, getSnapshot) => {
  const [state, setState] = useState(() => getSnapshot());
  useEffect(() => {
    const dispose = subscribe(() => {
      setState(() => getSnapshot());
    });
    return dispose;
  });
  return state;
};
export {
  useSyncExternalStore
};
